module.exports = __webpack_public_path__ + "static/media/MD.0b2eeb7d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/MD.svg
// module id = 309
// module chunks = 0